export default function Overview() {
  return (
    <div className="card">
      <div className="card-body">
        <h4 className="mb-3">ภาพรวมบัญชี</h4>
        <p className="text-muted mb-0">สรุปข้อมูลล่าสุดของบัญชี, คำสั่งซื้อ, สิทธิ์การใช้งาน ฯลฯ</p>
      </div>
    </div>
  );
}